import { motion } from 'framer-motion'
import styled from 'styled-components'

import { breakpoints, toRem } from '@/config/layout'

const FloatingLayoutContainer = styled.div`
  height: 100%;
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  grid-template-areas:
    '. logo logo logo logo logo logo logo logo logo logo .'
    '. main main main main main main main main main main .'
    '. . . . . . . . . . . .';
  grid-template-rows: 1fr 8fr 0.5fr;

  @media ${breakpoints.s} {
    grid-template-areas:
      '. logo logo logo logo logo logo logo logo logo logo .'
      '. main main main main main main main main . . .'
      '. . . . . . . . . . . .';
  }

  @media ${breakpoints.m} {
    grid-template-areas:
      '. logo logo logo logo logo logo logo logo logo logo .'
      '. main main main main main main . . . . .'
      '. . . . . . . . . . . .';
  }

  @media ${breakpoints.l} {
    grid-template-areas:
      '. logo logo logo logo logo logo logo logo logo logo .'
      '. main main main main . . . . . . .'
      '. . . . . . . . . . . .';
  }
`

const FloatingLayoutLogo = styled.div`
  width: 100%;
  margin-top: calc(var(--safe-area-inset-bottom) + 32px);
  grid-area: logo;
  max-height: 70px;
`

const FloatingLayoutContentContainer = styled.div`
  grid-area: main;
  margin-top: ${({ theme }) => theme.UI.SpacingPx.Space8};
  margin-bottom: ${({ theme }) => theme.UI.SpacingPx.Space8};
  display: flex;
  align-items: center;
  width: 100%;
  overflow: hidden;
`

const FloatingLayoutContent = styled.main`
  overflow-y: auto;
  width: 100%;
  max-height: 100%;
`

const FloatingLayoutBox = styled(motion.div)`
  background-color: ${({ theme }) => theme.Colors.Background.White};
  padding: ${toRem(32)};

  @media ${breakpoints.s} {
    padding: ${toRem(48)};
  }

  @media ${breakpoints.m} {
    padding: ${toRem(64)};
  }

  /* @media ${breakpoints.l} {
    padding: ${toRem(120)};
  } */
`

export {
  FloatingLayoutBox,
  FloatingLayoutContainer,
  FloatingLayoutContent,
  FloatingLayoutContentContainer,
  FloatingLayoutLogo,
}
